import m from 'mithril';
import { runQuery } from '../utils/fetchData';
import dataMap from '../utils/data';


String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};

export default {
  async oninit({ state }) {
    Object.assign(state, {
      name: '',
      stats: {},
    });

    const client = await dataMap.getClientData();

    Object.assign(state, client);
    m.redraw();

    // show a sentence case on the title
    document.title = `${state.name.toProperCase()} | Databank Enterprise`;
  },
  view({ state }) {
    const { projects = '...', submissions = '...' } = state.stats;
    return m('.k-content__head.k-grid__item',
      [
        m('.k-content__head-main', {
          'data-intro': 'This section contains simple statistics of the company',
          'data-position': 'right',
          'data-step': '6',
        },
        [
          m('h3.k-content__head-title',
            state.name.toProperCase()),
          m('.k-content__head-breadcrumbs',
            [
              m("a.k-content__head-breadcrumb-home[href='#']",
                m('i.flaticon2-shelter')),
              m('span.k-content__head-breadcrumb-separator'),
              // m("a.k-content__head-breadcrumb-link[href='']",
              //     'Devices: 0'),
              // m('span.k-content__head-breadcrumb-separator'),
              m('a.k-content__head-breadcrumb-link',
                `Projects: ${projects}`),
              m('span.k-content__head-breadcrumb-separator'),
              m('a.k-content__head-breadcrumb-link',
                `Submisions: ${submissions}`),
            ]),
        ]),
      ]);
  },
};
